import React from "react";

import RelatedItems from "components/related-items";

import { SanityRelatedItems } from "../types";

const RelatedItemsRenderer = ({ value }: { value: SanityRelatedItems }) => <RelatedItems {...value} />;

export default RelatedItemsRenderer;
